import {
  languages,
  defaultLanguage,
} from './../../assets/i18n/languages.index';
import produce from 'immer';
import { CHANGE_LOCALE } from './language-provider.actions';
import _ from 'lodash';

const languageSelector = () => {
  const navigatorLanguage = navigator.language.split(/[-_]/)[0];
  return _.includes(languages, navigatorLanguage)
    ? navigatorLanguage
    : defaultLanguage;
};

export const initialState = {
  locale: languageSelector(),
};

export const languageProviderReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case CHANGE_LOCALE:
        draft.locale = action.locale;
        break;
    }
  });
